import * as FeatherIcon from "react-feather";

const WarningFadedRed = ({ text }) => {
  return (
    <div style={styles.wrapper}>
      <span style={styles.icon}><FeatherIcon.AlertCircle height={"1rem"}/></span>
      <span style={styles.msg}>{text}</span>
    </div>
  );
};

const styles = {
  wrapper: {
    
    display: "flex",
    justifyContent:"center",
    alignItems:"center",
    

    gap: "0.2rem",
    padding: "0.3rem",
    borderRadius: "10px",
    background: "rgba(255, 59, 48, 0.10)", // faded red
    border: "1px solid rgba(255, 59, 48, 0.25)",
    backdropFilter: "blur(4px)",
    fontFamily: "Inter, sans-serif",
    color: "#b71c1c",
    fontSize: "0.9rem",
    fontWeight: 500,
  },
  
  msg: {
    lineHeight: 1.4,
  },
};

export default WarningFadedRed;
